export default "__VITE_ASSET__5355d95b__"